export const CATEGORIES = {
  Home: 'Home',
  Product: 'Product',
  Analysis: 'Analysis',
  Faq: 'Faq',
  Press: 'Press',
  AccountPortfolio: 'Account - Portfolio',
  Account: 'Account',
  Buying: 'Buying',
  Selling: 'Selling',
  Settings: 'Settings',
  Collection: 'Collection',
  PriceGuide: 'Price Guide',
  Contest: 'Contest',
  ContestEntries: 'Contest Entries',
  ReleaseCalendar: 'Release Calendar',
  Search: 'Search',
  SearchPage: 'Search Results Page',
  MultiAsk: 'Multi Ask',
  AccountExports: 'Account Exports',
  BulkShipping: 'Bulk Shipping',
  AccountSelling: 'Account Selling',
  AccountBuying: 'Account Buying',
  SellerProfile: 'Seller Profile',
  BuyingShipping: 'Buying - Shipping',
  BuyingBilling: 'Buying - Billing',
  AccountShipping: 'Account - Shipping',
  AccountBilling: 'Account - Billing',
  BuyingEntryForm: 'Buying - Entry Form',
  BuyingBuyNowForm: 'Buying - Buy Now Form',
  BuyingPlaceBidForm: 'Buying - Place Bid Form',
  BuyingShippingInfo: 'Buying - Shipping Info',
  BuyingPayment: 'Buying - Payment',
  BuyingReviewPurchase: 'Buying - Review Purchase',
  BuyingReviewBid: 'Buying - Review Bid',
  BuyingConfirm: 'Buying - Confirm',
  BrowseRecentlyViewedSwoosh: 'Browse Page Recently Viewed Swoosh',
  PDPRecentlyViewedSwoosh: 'Product Page Recently Viewed Swoosh',
  BuyingForm: 'Buying Form',
  ProductionPGFeaturedDescIndex: 'PRODUCTION_PG_FEATURED_DESC_INDEX',
  HTML_SITEMAP: 'HTML Sitemap',
  SellPriceGuidance: 'Selling Pricing Guidance',
  LocationModal: 'Choose Your Location Modal',
  AsSeenOnInstagram: 'As Seen on Instagram',
  BidFlow: 'Bid Flow',
  UpdateBidView: 'Update Bid View',
};
